import { Component } from "@angular/core";

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
    selector: 'card-access-renderer',
    templateUrl: './card-access-renderer.component.html',
    standalone: false
})
export class CardAccessRendererComponent implements ICellRendererAngularComp {
    public requestCount: number;
    params: any;

    initilize(params: ICellRendererParams) {
        this.requestCount = params.getValue();
    }

    // called on init
    agInit(params: any): void {
        this.initilize(params);
    }

    // called when the cell is refreshed
    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

}
